export default __webpack_public_path__ + "static/media/telegram.4f0063fc.svg";